import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { useForm, FormProvider, useWatch } from "react-hook-form";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";

import SaveCancel from "../../../components/SaveCancel";
import useCity from "../../../hooks/useCity";
import CityFields from "./components/CityFields";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";

const Card = styled(MuiCard)(spacing);

const timeOut = (time) => new Promise((res) => setTimeout(res, time));

const validationSchema = Yup.object().shape({
  cityName: Yup.string().required("Required"),
  taluk: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  district: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  state: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  country: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  status: Yup.string().required("Required"),
});

function BasicForm(props) {
  const dispatch = useDispatch();
  const [isSubmitBtn, setIsSubmitBtn] = useState(false);
  const [status, setStatus] = useState({
    sent: false,
  });

  const [errorSubmit, setErrorSubmit] = useState({
    submit: "",
  });
  const { getCity, city, updateCity, isSubmitting } = useCity();

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;
  const fetchData = async () => {
    await getCity(state.id);
  };
  const { state } = useLocation();

  React.useEffect(() => {
    if (Object.keys(city).length !== 0) {
      const initialValues = {
        cityId: city.cityId,
        cityName: city.cityName,
        country: {
          value: city.taluk?.district?.state?.country?.countryId,
          label: city.taluk?.district?.state?.country?.countryName,
        },
        state: {
          value: city.taluk?.district?.state?.stateId,
          label: city.taluk?.district?.state?.stateName,
        },
        district: {
          value: city.taluk?.district?.districtId,
          label: city.taluk?.district?.districtName,
        },
        taluk: {
          value: city.taluk?.talukId,
          label: city.taluk?.talukName,
        },
        status: city.status,
      };
      reset(initialValues);
    }
  }, [city]);

  useEffect(() => {
    fetchData();
  }, []);

  const { t } = props;

  const onSubmit = async (data) => {
    setIsSubmitBtn(true);
    try {
      const cityDTO = {
        cityId: data.cityId,
        country: {
          countryId: data.country.value,
        },
        state: {
          stateId: data.state.value,
        },
        district: {
          districtId: data.district.value,
        },
        taluk: {
          talukId: data.taluk.value,
        },
        status: data.status,
        cityName: data.cityName,
      };
      //console.log(districtDTO, "districtDTO");
      await updateCity(cityDTO);
      dispatch(showSuccessSnackbar("City updated successfully!"));
      navigate("/masters/city/list");
    } catch (err) {
      dispatch(showErrorSnackbar(err.message));
    }
    return false;
  };
  console.log(state, "location");

  const navigate = useNavigate();

  const cancelBtn = () => {
    navigate("/masters/city/list");
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_city")} subheader={"We can edit city here"} />
          <CardContent>
            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <CityFields />
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

function EditCity() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <BasicForm t={t} />
    </React.Fragment>
  );
}

export default EditCity;
